// @flow

import moment from 'moment';

export default function calculateEventStyle(event: MeetingEvent, hoursArg: number, startDate: Object, endDate: Object, datePickerStart: Object, datePickerEnd: Object) {
  let startDateCopy = moment.unix(startDate);
  let endDateCopy = moment.unix(endDate);
  startDateCopy = startDateCopy.hour(7).minute(0).second(0);
  endDateCopy = endDateCopy.hour(19).minutes(59).second(59);
  /* Takes an event and returns the correct style to display it properly in
   * the scheduler
  * */
  let percentHoursToStart = 0;
  let percentOfDay = 0;

  const schedulerDuration = endDateCopy.diff(startDateCopy, 'minutes') / 60; // eks 23,5
  const hours = Math.ceil(schedulerDuration); // get full days - 24 hours

  const startOfScheduler = moment(startDateCopy).hour(7).minute(0).second(0);

  if (!event.allDay) {
    const eventStart = event.start.local();
    const eventEnd = event.end.local();
    const eventDuration = eventEnd.diff(eventStart, 'minutes') / 60; // eks 2,5
    percentOfDay = (eventDuration / hours) * 100;

    const hoursToStart = eventStart.diff(startOfScheduler, 'minutes') / 60;
    percentHoursToStart = (hoursToStart / hours) * 100;
  } else {
    /*
    * when event is all day and date range selected for many days the indicator should cover only the event day
    * days : number of days
    * allDayPercentage: percentage of indicator to number of days
    */
    let allDayPercentage;
    if (hoursArg) {
      const days = (hoursArg / 24);
      allDayPercentage = Math.round(100 / days);
    } else {
      allDayPercentage = 100;
    }

    if (event.occupancy !== 'Free') {
      percentOfDay = allDayPercentage;
      // calculate margin left if event select in one day or different days in date range,
      if (datePickerStart && datePickerEnd && datePickerStart.diff(datePickerEnd, 'days') === 0) {
        percentHoursToStart = 0;
      } else {
        const eventStart = event.start.local().subtract(2, 'hours');
        const hoursToStart = eventStart.diff(startOfScheduler, 'minutes') / 60;

        percentHoursToStart = (hoursToStart / hours) * 100;
      }
    } else {
      // event is shown as free so don't show in scheduler
      return { display: 'none' };
    }
  }
  percentHoursToStart = percentHoursToStart < 0 ? 0 : percentHoursToStart;
  const style = {
    width: `${percentOfDay}%`,
    marginLeft: `${percentHoursToStart}%`,
  };
  return style;
}

// isAllDayInRange returns true if the event is an all day event that occurs on the given day
// the event might last for more than a day
export function isAllDayInRange(event: Object, day: moment) {
  if (!event.isAllDay) {
    return false;
  }

  // microsoft does not keep original TZ of an event if all day. It defaults to UTC, so i.e. startDate
  // won't match 12:00:00 AM of the expected day in other TZ != +00.

  // need to establish a valid format, otherwise moment.utc won't work (bug)
  // since the 'today' argument format is unreliable, better to enforce consistency here
  const noTzFmt = moment(day).format('MM DD YYYY');
  const noTz = moment.utc(noTzFmt, 'MM DD YYYY');
  const startOfDay = noTz.startOf('day').unix();
  const endOfDay = noTz.endOf('day').unix();
  return (event.startDate <= startOfDay && event.endDate > startOfDay) ||
          (event.startDate >= startOfDay && event.startDate < endOfDay && event.endDate >= endOfDay);
}



// WEBPACK FOOTER //
// ./src/js/libs/Event.js